import React, { useMemo } from "react";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import { Icon, Text } from "@bookingcom/bui-react";
import { arrayUtils } from "@flights/web-api-utils-universal";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import Frame from "../../../../components/elements/Frame/index.js";
import styles from "./InconsistentCabinBaggageInfo.module.css";
export const InconsistentCabinBaggageInfo = ({ includedProducts, renderTextOnly = false }) => {
    const i18n = useI18n();
    const isIncludedCabinBaggageInconsistentBetweenSegments = useMemo(() => {
        const cabinBaggageBySegment = includedProducts.segments.map((segment) => {
            return segment.some((item) => item.luggageType === "HAND");
        });
        return !arrayUtils.isConsistent(cabinBaggageBySegment);
    }, [includedProducts]);
    const shouldShow = isIncludedCabinBaggageInconsistentBetweenSegments;
    if (shouldShow) {
        return renderTextOnly ? (React.createElement(Text, null, i18n.trans(t("flights_cabin_bag_bound")))) : (React.createElement(Frame, { direction: "row", className: styles.root },
            React.createElement("div", null,
                React.createElement(Icon, { svg: InfoSignIcon, size: "larger", color: "accent" })),
            React.createElement("div", { className: styles.text },
                React.createElement(Text, { variant: "emphasized_2" }, i18n.trans(t("flights_cabin_bag_bound"))))));
    }
    else {
        return null;
    }
};
